<template>
  <WidgetPanel>
    <template #header>
      <div class="flex justify-between">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Als Nächstes empfohlen
        </h3>
        <button @click="overview">
          <RectangleStackOutlineIcon class="flex-shrink-0 h-5 w-5 text-gray-400" />
        </button>
      </div>
    </template>
    <template #default>
      <div v-if="empty" class="divide-y divide-gray-200">
        <div class="block hover:bg-gray-50">
          <div class="min-w-0 flex-1 flex items-center">
            <div class="flex items-center px-4 py-4 sm:px-6">
              <div class="min-w-0 flex-1 flex items-center">
                <p class="text-sm font-medium text-gray-600 truncate">
                  Bisher hast du noch keine Empfehlungen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul role="list" class="divide-y divide-gray-200">
        <li v-for="estimations in records" :key="estimations.id">
          <router-link :to="{name: 'practices.show', params: {id: estimations.practice_id}}" class="block hover:bg-gray-50">
            <div class="flex items-center px-4 py-4 sm:px-6">
              <div class="min-w-0 flex-1 flex items-center">
                <div class="flex-shrink-0">
                  <div class="flex justify-center items-center bg-gray-100 w-12 h-12 rounded-full">
                    <Twemoji :code="estimations.practice.emoji" class="w-6 h-6" />
                  </div>
                </div>
                <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-1 md:gap-4">
                  <div>
                    <p class="text-sm font-medium text-teal-600 truncate">
                      {{ estimations.practice.title }}
                    </p>
                    <p class="mt-2 flex items-center text-sm text-gray-500">
                      <Similarity :value="estimations.similarity" />
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <ChevronRightIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </template>
  </WidgetPanel>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useFetchResources } from '@/client/actions';

const props = defineProps({podcast: Object});

const router = useRouter();

const parent = computed(() => props.podcast.id);
const target = computed(() => '/api/podcasts/' + parent.value + '/estimations');

const { results, fetch, empty } = useFetchResources(target);

const records = computed(() => results.value.slice(0,3));

const overview = () => router.push({name: 'practices.list'});

const mounted = onMounted(fetch);
const watcher = watch(parent, fetch);
</script>

